module.exports = __webpack_public_path__ + "static/img/logo-login.e28be05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo-login.png
// module id = wCCF
// module chunks = 1